import { BrowserRouter, MemoryRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";

type AppProps = {
  staticPath?: string;
};

function App({ staticPath }: AppProps) {
  return (
    <I18nextProvider i18n={i18n}>
      {staticPath ? (
        <MemoryRouter basename={__BASE_PATH__} initialEntries={[staticPath]}>
          <AppRoutes />
        </MemoryRouter>
      ) : (
        <BrowserRouter basename={__BASE_PATH__}>
          <AppRoutes />
        </BrowserRouter>
      )}
    </I18nextProvider>
  );
}

export default App;
